import React, { useEffect, useState } from "react";
import timeIcon from "../../../../../assets/icons/time.png";

const CustomAlertModal = ({ isOpen, onClose, onNavigate }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      setTimeout(() => setIsVisible(false), 300);
    }
  }, [isOpen]);

  if (!isOpen && !isVisible) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Add ripple effect
    const button = e.currentTarget;
    const ripple = document.createElement("span");
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.classList.add("ripple");

    button.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);

    onNavigate();
  };

  return (
    <>
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-black transition-all duration-500 ease-out ${
          isVisible ? "opacity-100" : "opacity-0"
        } ${isOpen ? "bg-opacity-30" : "bg-opacity-0"}`}
        onClick={handleBackdropClick}
      >
        <div
          className={`bg-white rounded-3xl max-w-md w-full px-6 sm:px-8 py-5 sm:py-6 text-center shadow-2xl relative transform transition-all duration-500 ease-out ${
            isAnimating && isOpen
              ? "scale-100 opacity-100 translate-y-0"
              : "scale-90 opacity-0 translate-y-8"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Animated background gradient */}
          <div className="absolute inset-0 rounded-3xl overflow-hidden pointer-events-none">
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-gradient-to-br from-[#8AB9F1] via-[#B57EDC] to-[#F08080] rounded-full opacity-10 blur-3xl animate-pulse"></div>
            <div
              className="absolute -bottom-20 -left-20 w-64 h-64 bg-gradient-to-tr from-[#F08080] via-[#B57EDC] to-[#8AB9F1] rounded-full opacity-10 blur-3xl animate-pulse"
              style={{ animationDelay: "1s" }}
            ></div>
          </div>

          <div className="relative z-10">
            <h1
              className={`text-4xl font-handwriting text-[#141A33] mb-4 transition-all duration-700 delay-100 ease-out ${
                isAnimating
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-4"
              }`}
            >
              Sorry!
            </h1>

            <p
              className={`text-gray-600 mb-6 transition-all duration-700 delay-200 ease-out ${
                isAnimating
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-4"
              }`}
            >
              We don't think you can <br /> save money based on your answers.
            </p>

            <div
              className={`flex items-center justify-center gap-2 mb-4 transition-all duration-700 delay-300 ease-out ${
                isAnimating ? "opacity-100" : "opacity-0"
              }`}
            >
              <div className="flex-grow border-t border-gray-200"></div>
              <span className="text-sm text-gray-400">But</span>
              <div className="flex-grow border-t border-gray-200"></div>
            </div>

            <div
              className={`mb-4 transition-all duration-700 delay-400 ease-out ${
                isAnimating ? "opacity-100 scale-100" : "opacity-0 scale-95"
              }`}
            >
              <img
                src={timeIcon}
                alt="time"
                className="w-8 h-8 mx-auto"
              />
            </div>

            <p
              className={`text-gray-600 mb-6 transition-all duration-700 delay-500 ease-out ${
                isAnimating
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-4"
              }`}
            >
              You may be able to get a refund for{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8AB9F1] via-[#B57EDC] to-[#F08080] font-semibold">
                past tax year
              </span>
            </p>

            <button
              onClick={handleButtonClick}
              className={`w-full bg-[#002147] text-white py-3.5 rounded-xl font-semibold hover:bg-[#001730] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden ${
                isAnimating
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-4"
              }`}
              style={{ transitionDelay: isAnimating ? "600ms" : "0ms" }}
            >
              <span className="relative z-10">Next →</span>
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes ripple {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        .ripple {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.6);
          transform: scale(0);
          animation: ripple 600ms ease-out;
          pointer-events: none;
          z-index: 1;
        }
      `}</style>
    </>
  );
};

export default CustomAlertModal;
